export const searchFormOptionA = function () {
    return [
        {
            prop: "keyword",
            label: "关键字",
            type: "input",
            placeholder: "请输入车牌号/车架号",
            width: "20%",
        },
    ]
}

export const searchFormOptionB = function () {
    return [
        {
            prop: "keyword",
            label: "关键字",
            type: "input",
            placeholder: "请输入姓名/证件号",
            width: "20%",
        },
    ]
}

export const columnsA = function () {
    return [
        {
            prop: "carNo",
            label: "车牌号",
            minWidth: 200,
        },
        {
            prop: "vin",
            label: "车架号",
            minWidth: 100,
        },
        {
            prop: "addPerson",
            label: "添加人",
            minWidth: 100,
        },
        {
            prop: "createdAt",
            label: "增加时间",
            minWidth: 200,
        },
        {
            prop: "bz",
            label: "备注",
            minWidth: 100,
        },
        {
            prop: "handle",
            label: "操作",
            minWidth: 150,
        },
    ]
}

export const columnsB = function () {
    return [
        {
            prop: "personName",
            label: "姓名",
            minWidth: 200,
        },
        {
            prop: "cardNo",
            label: "证件号",
            minWidth: 100,
        },
        {
            prop: "addPerson",
            label: "添加人",
            minWidth: 100,
        },
        {
            prop: "createdAt",
            label: "增加时间",
            minWidth: 200,
        },
        {
            prop: "bz",
            label: "备注",
            minWidth: 100,
        },
        {
            prop: "handle",
            label: "操作",
            minWidth: 150,
        },
    ]
}

export const rules = function () {
    return {
        orgName: [
            { required: true, message: '请输入机构名称', trigger: ['blur', 'change'] },
        ],
        orgNo: [
            { required: true, message: '请输入机构编号', trigger: ['blur', 'change'] },
        ],
        leader: [
            { required: true, message: '请输入负责人', trigger: ['blur', 'change'] },
        ],
        tel: [
            { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
        ],
        addr: [
            { required: true, message: '请选择注册日期', trigger: ['blur', 'change'] },
        ]
    }
}

export default {}